import type { Step } from "onborda";
import { 
  Home, 
  BookOpen, 
  Award, 
  User,
  Search
} from "lucide-react";

export const userOnboardingSteps: Step[] = [
  {
    icon: <Home className="h-5 w-5" />,
    title: "Welcome to Your Dashboard!",
    content: "This is your personal learning hub. Let's take a quick tour to help you get started with your courses.",
    selector: "#user-dashboard-title",
    side: "bottom",
    showControls: true,
    pointerPadding: 10,
    pointerRadius: 8,
  },
  {
    icon: <BookOpen className="h-5 w-5" />,
    title: "Your Courses",
    content: "Here you'll find all your enrolled courses. Click on any course to continue where you left off or start a new one.",
    selector: "#courses-tab",
    side: "bottom",
    showControls: true,
    pointerPadding: 10,
    pointerRadius: 8,
  },
  {
    icon: <Award className="h-5 w-5" />,
    title: "Track Your Progress",
    content: "View your course completion status, certificates earned, and overall learning progress. Stay motivated!",
    selector: "#progress-tab",
    side: "bottom",
    showControls: true,
    pointerPadding: 10,
    pointerRadius: 8,
  },
  {
    icon: <Search className="h-5 w-5" />,
    title: "Search for Courses",
    content: "Use the search bar to quickly find specific courses, lessons, or topics you're interested in learning about.",
    selector: "#search-trigger",
    side: "bottom-left",
    showControls: true,
    pointerPadding: 10,
    pointerRadius: 8,
  },
  {
    icon: <User className="h-5 w-5" />,
    title: "Your Account",
    content: "Access your profile settings, view your achievements, and manage your account preferences from here.",
    selector: "#user-menu",
    side: "bottom-left",
    showControls: true,
    pointerPadding: 10,
    pointerRadius: 8,
  },
  {
    icon: <Home className="h-5 w-5" />,
    title: "You're All Set!",
    content: "That's everything! Start exploring courses and begin your learning journey. You can restart this tour anytime from your account settings.",
    selector: "#user-dashboard-title",
    side: "bottom",
    showControls: true,
    pointerPadding: 10,
    pointerRadius: 8,
  },
];

// LocalStorage keys
export const USER_TOUR_SEEN_KEY = "user-onboarding-tour-seen";

// Helper functions
export function hasSeenUserTour(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(USER_TOUR_SEEN_KEY) === "true";
}

export function markUserTourAsSeen(): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(USER_TOUR_SEEN_KEY, "true");
}

export function resetUserTour(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(USER_TOUR_SEEN_KEY);
}

